export const SLIDE_TYPES = {
  COVER: "cover",
  INCLUSIONS: "inclusions",
  EXCLUSIONS: "exclusions",
  ITINERARY: "Itinerary",
  HIGHLIGHTS: "Highlights",
  HOTELS: "hotels",
  FLIGHTS: "flights",
  TRANSPORT: "transport",
  PRICE: "Price",
  TERMS: "Terms",
  CONTACT: "Contact",
  MAP: "Map",
  CUSTOM: "Custom",
  POLICY: "Policy",
  THANKYOU: "thankyou",
};
